var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShockMegatron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F0FBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.3337V18.0004M18 20.667H18.0067M23.25 14.1804C23.7167 14.4457 24.0033 14.9424 24 15.479V20.335C24 20.8744 23.7047 21.3717 23.228 21.6337L18.728 24.4804C18.5049 24.6029 18.2545 24.6671 18 24.6671C17.7455 24.6671 17.4951 24.6029 17.272 24.4804L12.772 21.6337C12.5388 21.5063 12.3441 21.3185 12.2083 21.09C12.0725 20.8616 12.0005 20.6008 12 20.335V15.4784C12 14.939 12.2953 14.4424 12.772 14.1804L17.272 11.527C17.5017 11.4004 17.7597 11.334 18.022 11.334C18.2843 11.334 18.5423 11.4004 18.772 11.527L23.272 14.1804H23.25Z",
    stroke: "#1E5915",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShockMegatron);
export default __webpack_public_path__ + "static/media/ShockMegatron.cd79b4df82be3e52ed1135d9ef622251.svg";
export { ForwardRef as ReactComponent };